// extracted by mini-css-extract-plugin
var _1 = "RequestProfileTabs-moduledivider__A3Vgp Divider-moduleDivider__dL3Vg";
var _2 = "RequestProfileTabs-moduletab__QlJnh Tab-moduleTab__yRe6s";
var _3 = "RequestProfileTabs-moduletabsWrapper__cq9Jt TabScrollList-modulewrapper__zIrvw";
export { _1 as "divider", _2 as "tab", _3 as "tabsWrapper" }
